import { ReschedulerContextData } from './types';
import { InternalScheduleRespSuccess } from '@services/schedules/internal/types';
import isObjectEmpty from '@utils/isObjectEmpty';

export const handleRelatedSchedulesResponse = (
  rescheduler: ReschedulerContextData,
  resp: InternalScheduleRespSuccess,
) => {
  const {
    data: updatedSchedule,
    relatedSchedules: relatedSchedulesFromResp,
    scheduleSummary,
  } = resp;
  if (!updatedSchedule) return;

  const isRelatedSchedulesArrayEmpty = !rescheduler.relatedSchedules.length;

  rescheduler.setState((prev) => {
    let nextRelated = prev.relatedSchedules;

    if (isRelatedSchedulesArrayEmpty && relatedSchedulesFromResp?.length) {
      nextRelated = [...prev.relatedSchedules, ...relatedSchedulesFromResp].map((el) =>
        el.task?.id === updatedSchedule.task?.id ? { ...el, ...updatedSchedule } : el,
      );
    } else if (!isRelatedSchedulesArrayEmpty) {
      nextRelated = prev.relatedSchedules.map((el) =>
        el.task?.id === updatedSchedule.task?.id ? { ...el, ...updatedSchedule } : el,
      );
    }

    return {
      ...prev,
      relatedSchedules: nextRelated,
      scheduleSummary,
      schedule:
        isRelatedSchedulesArrayEmpty && relatedSchedulesFromResp?.length
          ? updatedSchedule
          : prev.schedule,
      open:
        (isRelatedSchedulesArrayEmpty && Boolean(relatedSchedulesFromResp?.length)) || prev.open,
      showSummary:
        (!relatedSchedulesFromResp?.length && !isObjectEmpty(scheduleSummary)) || prev.showSummary,
    };
  });

  if (isRelatedSchedulesArrayEmpty) return;
  rescheduler.appendSavedSchedule(updatedSchedule);
};
